import { Component, OnInit, Input, ViewChild, AfterViewInit, ElementRef, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { of } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { APP_Constants } from 'src/app/app.constant';
import { AppService } from 'src/app/app.service';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { DhlFormControlEventData } from '../../dhl-form/models/dhl-form-control-event-data';
import { SearchBoxDataService } from '../../dhl-form/services/searchboxdata.service';
import { TranslateService } from '@ngx-translate/core';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';

@Component({
    selector: "app-search-box-v2",
    templateUrl: "./search-box-v2.component.html",
    styleUrls: ["./search-box-v2.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchBoxV2Component implements OnInit, AfterViewInit {
  @Input() configData: any;
  suggestionList = [];
  private searchTerms = new Subject<any>();
  public searchValue = "";
  public searchTextLocal;
  flag: boolean = false;
  public selectedItems: Array<any>;
  highlightBorder: boolean = false;
  suggestion: any;
  isFocused: boolean = false;
  responseData;
  isBackspace: boolean = false;
  isEnableFilterSearch: string;

  history: boolean = false;
  historyList = [];
  errorMessage: string;
  hasSearchError: boolean = false;

  @ViewChild("searchBox", {static: false, read: ElementRef}) searchBox: ElementRef;
  @ViewChild("searchContainer", {static: true, read: ElementRef}) searchContainer;

  constructor(
    private searchBoxDataService: SearchBoxDataService,
    private appService: AppService,
    private _eref: ElementRef,
    private modalService: ModalService,
    public translate: TranslateService,
    private alphaService : AlphaService

  ) {
    this.selectedItems = [];
  }
  normalView() {
    document.getElementById("overlay").style.display = "none";
  }

  ngOnInit(): void {
    this.isEnableFilterSearch = localStorage.getItem("isEnableFilterSave");
    // search start
    this.suggestion = this.configData.suggestion;
    if (this.configData.showSuggestion !== false) {
      this.searchTerms.pipe(debounceTime(CommonConfig.ORDER_SEARCH_TIMEOUT))
        .subscribe((obj) => {
          if (this.configData.isMultiTextSearch === true) {
            obj.data = obj.data.toUpperCase()
            if (this.suggestion === false) {
              this.sendToSource({ data: obj.data }, obj.userEvent);

            } else if (obj.data.length >= 3 && obj.data != null) {
              if (this.history) {
                this.keepHistory(obj.data);
              }
              let url;

              url = this.configData.suggestApiUrl + "suggestionText=" + obj.data;
              url += '&customerCode=' + localStorage.getItem('customerCode');
              url += '&userId=' + localStorage.getItem('userName') + '&action=suggestion';
              this.appService.makeHttpGetRequest(url).subscribe(response => {
                this.responseData = response;
                if (this.responseData.message.statusCode == "SUCCESS") {
                  this.suggestionList = this.responseData.data.suggestionList;
                }
              }, error => {
                console.log("error" + error);
                this.normalView();

                let modal = new Modal({
                  action: false, name: 'Search', title: 'Something went wrong', description: error.message, actionButtonText: ''
                });
                this.modalService.createModalBox(modal, error.status);
              });
            }
          }
          else if (this.suggestion === false) {
            this.sendToSource({ data: obj.data }, obj.userEvent);

          } else if (obj.data.length >= 3 && obj.data != null) {
            if (this.history) {
              this.keepHistory(obj.data);
            }
            let url;
            url = this.configData.suggestApiUrl + "suggestionText=" + obj.data;
            url += '&customerCode=' + localStorage.getItem('customerCode');
            url += '&userId=' + localStorage.getItem('userName') + '&action=suggestion';
            this.appService.makeHttpGetRequest(url).subscribe(response => {
              this.responseData = response;
              if (this.responseData.message.statusCode == "SUCCESS") {
                this.suggestionList = this.responseData.data.suggestionList;
              }
            }, error => {
              console.log("error" + error);
              this.normalView();

              let modal = new Modal({
                action: false, name: 'Search', title: 'Something went wrong', description: error.message, actionButtonText: ''
              });
              this.modalService.createModalBox(modal, error.status);
            });
          }
          else if (this.suggestion === false) {
            this.sendToSource({ data: obj.data }, obj.userEvent);

          } else if (obj.data.length >= 3 && obj.data != null) {
            if (this.history) {
              this.keepHistory(obj.data);
            }
            let url;
            url = this.configData.suggestApiUrl + "suggestionText=" + obj.data;
            url += '&customerCode=' + localStorage.getItem('customerCode');
            url += '&userId=' + localStorage.getItem('userName') + '&action=suggestion';
            this.appService.makeHttpGetRequest(url).subscribe(response => {
              this.responseData = response;
              if (this.responseData.message.statusCode == "SUCCESS") {
                this.suggestionList = this.responseData.data.suggestionList;
              }
            }, error => {
              console.log("error" + error);
              this.normalView();

              let modal = new Modal({
                action: false, name: 'Search', title: 'Something went wrong', description: error.message, actionButtonText: ''
              });
              this.modalService.createModalBox(modal, error.status);
            });
          } else {
            this.fetchHistory();
          }
          console.log(obj.data);
        });
    }
    // search end
  }

  ngAfterViewInit() {
   // this.suggestion = this.configData.suggestion;
    this.history = this.configData.history;
    if(this.configData.hasOwnProperty("storeDataName")){
      if (sessionStorage.getItem(this.configData.storeDataName)) {
        this.searchTextLocal = sessionStorage.getItem(this.configData.storeDataName);
        if(this.suggestion){
          if(Array.isArray(JSON.parse(this.searchTextLocal))){
            if (this.configData.separateByComma || this.configData.separateByCommaAndSpace) {
              this.searchBox.nativeElement.value = JSON.parse(this.searchTextLocal);
              this.onselect(null, this.searchBox.nativeElement.value);
            }
            else {  
              this.searchTextLocal = JSON.parse(this.searchTextLocal);
              this.searchTextLocal.forEach(element => {
                this.searchBox.nativeElement.value = element;
                this.onselect(null, this.searchBox.nativeElement.value);
              });
            }          
          }  
        }
        else {
          this.searchBox.nativeElement.value = this.searchTextLocal;
          this.onselect(null,this.searchBox.nativeElement.value);
        }

        // if(Array.isArray(this.searchTextLocal) && this.searchTextLocal.length){
        //   this.searchTextLocal.forEach(element => {
        //     this.searchBox.nativeElement.value = element;
        //     this.onselect(this.searchBox.nativeElement.value);
        //   });
        // } else {
        //   this.searchBox.nativeElement.value = this.searchTextLocal;
        //   this.onselect(this.searchBox.nativeElement.value);
        // }
       //this.suggestionList = this.searchBox.nativeElement.value.split(',');
       this.flag = false;
      }
    }

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      this.searchBox.nativeElement.value = filterObj[this.configData.name];
    }
  }

  // Push a search term into the observable stream.
  search(userEvent): void {
    this.flag = true;
    this.searchValue = this.searchBox.nativeElement.value;
    this.searchValidation();

    if (this.hasSearchError) {
      return;
    }

    this.appService.sendMassiveSearchBoxData(this.searchValue);
    this.searchTerms.next({data: encodeURIComponent(this.searchValue), 'userEvent': userEvent});
    // if (this.suggestion === false) {
    //   this.searchTerms.next(term);
    // }else if (term.length >= 3 && term != null) {
    //   if(this.history){
    //     this.keepHistory(term);
    //   }
    //   let url;
    //   url = this.configData.suggestApiUrl + "suggestionText=" + term;
    //   this.appService.makeHttpGetRequest(url).subscribe(response => {
    //     this.responseData = response;
    //     if (this.responseData.message.statusCode == "SUCCESS") {
    //       this.suggestionList = this.responseData.data.suggestionList;
    //     }
    //   }, error => {
    //     console.log("error" + error);
    //     this.normalView();

    //     let modal = new Modal({
    //       action: false, name: 'Search', title: 'Something went wrong', description: error.message, actionButtonText: ''
    //     });
    //     this.modalService.createModalBox(modal, error.status);
    //   });
    // }else{
    //   this.fetchHistory();
    // }
  }

  onBackspace(userEvent){
    this.isBackspace = true;
  }
  onPaste(userEvent){
    this.clearRef(userEvent);
    this.search(userEvent);
  }

  searchValidation() {
    const maxLength = Number(this.configData.maxLength);
    if (maxLength > 0 && this.searchValue.length > maxLength) {
      this.errorMessage = `Search value should not exceed ${maxLength} characters`;
      this.hasSearchError = true;
    } else {
      this.errorMessage = "";
      this.hasSearchError = false;
    }
  }

  clearHistory(){
    this.historyList = [];
    let history = JSON.parse(localStorage.getItem("searchHistory"));
    history[this.configData.historyName] = [];
    localStorage.setItem("searchHistory", JSON.stringify(history));
  }

  fetchHistory(){
    if(localStorage.getItem("searchHistory") != null && this.configData.hasOwnProperty("historyName")){
      let history = JSON.parse(localStorage.getItem("searchHistory"));
      if(history.hasOwnProperty(this.configData.historyName)){
        this.flag = true;
        this.historyList = history[this.configData.historyName]; //["test 123", "test 456"];
      }else{
        this.historyList = [];
      }
    }else{
      if(!this.configData.hasOwnProperty("historyName")){
        console.log("Missing >> historyName property missing in configData for the search component");
      }
      if(localStorage.getItem("searchHistory") == null){
        localStorage.setItem("searchHistory", JSON.stringify({}))
      }
    }
  }

  keepHistory(searchTxt: string): void{
    if(localStorage.getItem("searchHistory") != null && this.configData.hasOwnProperty("historyName")){
      let history = JSON.parse(localStorage.getItem("searchHistory"));
      if(history.hasOwnProperty(this.configData.historyName)){
        let historyList = history[this.configData.historyName];
        if(historyList && !historyList.length){
          historyList = [];
        }
        historyList.push(searchTxt);
        historyList = historyList.filter((v,i) => historyList.indexOf(v) === i);
        history[this.configData.historyName] = historyList;
      }else{
        history[this.configData.historyName] = [];
        this.historyList = [];
      }
      localStorage.setItem("searchHistory", JSON.stringify(history));
    }
  }

  sendToSource(sourceData, userEvent) {
    let events = this.configData.events;
    let queryString = this.generateQueryString(sourceData);

    let eventData: DhlFormControlEventData = {
      event: events[0].event,
      eventData: events[0],
      action: events[0].event.toUpperCase(),
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: {value: sourceData.data, queryString: queryString}
    }
    let searchPayload = {};
    if(sourceData.data && sourceData.data.length > 0) {
      searchPayload[this.configData.name] =[{
        "operator": this.configData['operator'],
        "value": sourceData.data
      }];
    }
    if(this.configData.hasOwnProperty("storeDataName")){
      sessionStorage.setItem(this.configData.storeDataName + '-Payload', JSON.stringify(searchPayload));
      if(this.suggestion){
        sessionStorage.setItem(this.configData.storeDataName, JSON.stringify(sourceData.data));
      } else{
        sessionStorage.setItem(this.configData.storeDataName, sourceData.data);
      }
      // if(Array.isArray(sourceData.data)){
      //   sessionStorage.setItem(this.configData.storeDataName, JSON.stringify(sourceData.data));
      // } else{
      //   sessionStorage.setItem(this.configData.storeDataName, sourceData.data);
      // }

    }
    eventData['userEvent'] = userEvent;
    eventData['searchPayload'] = searchPayload;

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj) {
      filterObj[this.configData.name] = decodeURIComponent(sourceData.data);
      this.searchBox.nativeElement.value = decodeURIComponent(sourceData.data);
      this.alphaService.setFilteredObject('setFiltersValues', filterObj);
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  generateQueryString(sourceData){
    let queryString = '';
    if (Array.isArray(sourceData.data)) {
      sourceData.data.forEach((ele) => {
        queryString += '&' + this.configData.name + '=' + encodeURIComponent(ele.trim());
      });
     } else {
      queryString += '&' + this.configData.name + '=' + encodeURIComponent(sourceData.data);
     }
     return queryString;
  }

  onselect(userEvent, obj=this.searchBox.nativeElement.value ) {
    if(this.isBackspace && this.isEnableFilterSearch){
      this.clearRef(userEvent);
      this.isBackspace = false;
    }
    // if(this.suggestion){
    //   this.searchText = "";
    // }
    // this.flag = false;
    // this.history = false;
    // this.selectedItems.push(obj);
    // this.sendToSource({ data: obj });
    // what is obj and obj.id, fix it below commented code properly and can uncomment above

    //Cp-8287 - separate by comma - start
    obj = obj.trim().replace(/,+$/, '').trim();
    let objArrWithNullVals; //Array when txt is separated by ","
    let objArrWithoutNullVals; //Array without empty values
    if (obj && (this.configData.separateByComma || this.configData.separateByCommaAndSpace)) {

      if(this.configData.separateByComma){
        objArrWithNullVals = obj.split(",").map(item => item.trim());        
      }
      else if(this.configData.separateByCommaAndSpace){
        objArrWithNullVals = obj.split(/[ ,]+/).map(item => item.trim());
      }    
      
      objArrWithoutNullVals = [];
      objArrWithNullVals.forEach(txt => {
        if (txt) {
          objArrWithoutNullVals.push(txt);
        }
      })
      if (objArrWithoutNullVals.length === 0) {
        obj = "";
      }
    }
    //Cp-8287 - separate by comma - end

    let searchText = sessionStorage.getItem(this.configData.storeDataName);
    let searchArray = JSON.parse(sessionStorage.getItem(this.configData.storeDataName));
    if (obj || (!obj && searchText && Array.isArray(searchArray) && searchArray.length > 0)) {
      if ((obj.Id != 0) || (!obj && searchText && Array.isArray(searchArray) && searchArray.length > 0)) {
        if (this.suggestion) {
          this.searchBox.nativeElement.value = "";
        }
        this.flag = false;
        this.history = false;

        if (objArrWithoutNullVals && objArrWithoutNullVals.length > 0 && (this.configData.separateByComma || this.configData.separateByCommaAndSpace)) { //Cp-8287
          this.selectedItems = this.selectedItems.concat(objArrWithoutNullVals);
        }
        else if(obj) {
          if (this.configData?.enableSaveFilterGsk) {
            this.selectedItems = [];
          }
          this.selectedItems.push(obj);
        }

        this.selectedItems = Array.from(new Set(this.selectedItems)); //CP-8425

        this.searchBox.nativeElement.value = "";
        this.searchValue = "";
        this.sendToSource({ data: this.selectedItems }, userEvent);
      } else {
        return false;
      }
    } else {

    }
  }

  removeItem(item, userEvent) {
    const index = this.selectedItems.indexOf(item, 0);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
      this.sendToSource({ data: this.selectedItems }, userEvent);
    }
  }

  setFocus(val) {
    this.isFocused = val;
    this.searchContainer.nativeElement.classList.remove(
      "search-container-hover"
    );
    if (this.history && val) {
      this.flag = true;
      this.fetchHistory();
    }
  }

  close(userEvent) {
    this.selectedItems = [];
    this.flag = false;
    this.searchBox.nativeElement.value = "";
    sessionStorage.removeItem(this.configData.storeDataName);
    //this.searchTerms.next(this.searchBox.nativeElement.value);
    this.sendToSource({ data: this.searchBox.nativeElement.value }, userEvent);
    this.errorMessage = "";
    this.hasSearchError = false;
  }

  clearRef(userEvent) {
    this.selectedItems = [];
    this.flag = false;
    sessionStorage.removeItem(this.configData.storeDataName); 
    this.errorMessage = "";
    this.hasSearchError = false;
  }

  focusInput() {
    if (this.searchBox) {
      this.searchBox.nativeElement.focus();
      //this.isFocused = true;
    }
    this.searchContainer.nativeElement.classList.remove(
      "search-container-hover"
    );
  }

  @HostListener('document:click', ['$event'])
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target))
      // or some similar check
      this.flag = false;
  }

  setHover(val) {
    if (!this.isFocused) {
      this.searchContainer.nativeElement.classList.add(
        "search-container-hover"
      );
    }
    if (!val) {
      this.searchContainer.nativeElement.classList.remove(
        "search-container-hover"
      );
    }
  }
}